import { WSIncomeMessage, WSOutcomeMessage } from 'components/features/webSocket/types'
import { createAction } from 'helpers/actionHelpers/createAction'

export class WsOpenAction extends createAction<'WS_OPEN', void>('WS_OPEN') {}

export class WsSendAction extends createAction<'WS_SEND', WSOutcomeMessage>('WS_SEND') {}

export class WsMessageAction extends createAction<'WS_MESSAGE', WSIncomeMessage>('WS_MESSAGE') {}

export type WsActions =
  | WsOpenAction
  | WsSendAction
  | WsMessageAction
